// monstrs 公開API のリクエスト組み立て（お知らせ取得・添付DL）。
// お知らせ取得パラメータの後方互換を守るため、ここを単一の真実とする。

export function messageListRequest (apiBase) {
  return {
    url: `${apiBase}/public/message/list`,
    params: { published: true, page: 0, perPage: 10 }
  }
}

export function messageDetailUrl (apiBase, id) {
  return `${apiBase}/public/message/${id}`
}

export function attachmentDownloadRequest (apiBase, blobName) {
  return {
    url: `${apiBase}/public/attachment/url/dl`,
    params: { blobName }
  }
}

export function releaseListRequest (apiBase, page = 0, perPage = 20) {
  return {
    url: `${apiBase}/public/releases`,
    params: { page, perPage }
  }
}
